import React from "react";
import { Slider } from "@mui/material";
import { createUseStyles } from "react-jss";
import { Text, IField, useFormContext } from "$components";
import { theme } from "$utils/theme/bataillog";

function SliderInput({
  label,
  className,
  name,
  max,
  min,
  value: DefValue,
  defaultValue = "1",
}: IField) {
  const classes = useStyles();
  const context = useFormContext();
  const slider = context[name];
  const { values, setFormValues } = context;

  const [inputValue, setInputValue] = React.useState<any>({
    value: (values[name]?.value || 1).toString() || defaultValue,
  });

  const setStateValue = (dataInput: any) => {
    const newValue = {
      ...inputValue,
      ...dataInput,
    };
    setInputValue(newValue);
    setFormValues((prev: any) => ({
      ...prev,
      [name]: {
        ...values[name],
        ...inputValue,
        ...dataInput,
      },
    }));
  };

  const handleChange = (event: any, newValue: number | number[]) => {
    setStateValue({
      value: newValue.toString(),
    });
  };

  const val = parseInt(inputValue?.value, 10);

  let classname = classes.SliderMedium;
  if (val === 0) {
    classname = classes.SliderLess;
  }
  if (val === 1) {
    classname = classes.SliderMedium;
  }
  if (val === 2) {
    classname = classes.SliderMore;
  }

  let textValue: string;
  if (inputValue?.value === "0") {
    textValue = "Faible";
  } else if (inputValue?.value === "1") {
    textValue = "Moyenne";
  } else {
    textValue = "Forte";
  }

  React.useEffect(() => {
    if (DefValue?.value) {
      setInputValue((prev: any) => ({
        ...prev,
        ...DefValue,
      }));
    }
  }, [DefValue]);

  React.useEffect(() => {
    if (slider?.value) {
      setInputValue((prev: any) => ({
        ...prev,
        ...slider,
      }));
    }
  }, [slider]);

  return (
    <div className={`${classes.inputGroup} ${className || ""}`}>
      {label && (
        <label className={classes.inputLabel} htmlFor={name}>
          <Text>{label}</Text>
        </label>
      )}
      <div className={classes.SliderToolTip}>{textValue}</div>
      <Slider
        name={name}
        className={classname}
        max={max}
        value={inputValue?.value}
        min={min}
        onChange={handleChange}
        color="primary"
      />
    </div>
  );
}
export default React.memo(SliderInput);

const useStyles = createUseStyles(() => ({
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "14px",
    flex: 1,
    marginRight: "10px",
  },
  inputLabel: {
    marginBottom: "10px",
  },
  selectInput: {
    flex: 1,
    border: `1px solid ${theme.color.gray2}`,
    paddingLeft: 10,
    paddingRight: 10,
    "&:before": {
      display: "none",
    },
    "& .MuiInput-input": {
      height: 29,
      fontSize: 15,
      display: "flex",
      alignItems: "center",
    },
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  SliderLess: {
    "&.MuiSlider-root": {
      color: `${theme.color.red} !important`,
    },
  },
  SliderMedium: {
    "&.MuiSlider-root": {
      color: `${theme.color.orange} !important`,
    },
  },
  SliderMore: {
    "&.MuiSlider-root": {
      color: `${theme.color.green} !important`,
    },
  },
  SliderToolTip: {
    fontSize: 12,
  },
}));
